import PrintText from "./PrintText";

export default PrintText;
